import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'utils/axios';

// GET ALL COURIERS
export const getAllCouriers = createAsyncThunk('couriers/getAllCouriers', async (page = 1, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/couriers?limit=10&page=${page}`);
    const data = await response.data;
    return data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.response.data);
  }
});

// GET DETAIL TASK COURIER
export const getDetailTaskCourier = createAsyncThunk(
  'couriers/getDetailTaskCourier',
  async (transaction_key, thunkAPI) => {
    try {
      const response = await axiosInstance.get(`/admin/orders/${transaction_key}/tasks`);
      const data = await response.data;
      return data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  },
);

// ASSIGN COURIER TO TASK
export const assignCourier = createAsyncThunk('couriers/assignCourier', async (payload, thunkAPI) => {
  try {
    const response = await axiosInstance.post(`/tasks`, { ...payload });
    const data = await response.data;
    return data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});
